import PlansAndBilling from '~/components/PlansAndBilling';
import { useCurrentUser } from '~/components/profile/useCurrentUser';
import { PageLayout } from '~/components/unified/PageLayout';

import { LoadingUpgradeSkeleton } from './PageTeamGrowthUpgrade';

export const PageTeamPlansAndBilling = () => {
  const account = useCurrentUser().account;

  const isLoading = !account;

  return (
    <PageLayout>
      <PageLayout.Header className="border-none">
        <PageLayout.Heading>Plans & Billing</PageLayout.Heading>
        <PageLayout.SubHeading>
          {isLoading ? (
            'Loading...'
          ) : (
            <>
              Your team — <strong>{account.name}</strong> — is currently on the
              Free plan.
            </>
          )}
        </PageLayout.SubHeading>
      </PageLayout.Header>
      <PageLayout.Body className="bg-white">
        {isLoading ? <LoadingUpgradeSkeleton /> : <PlansAndBilling />}
      </PageLayout.Body>
    </PageLayout>
  );
};
